import { Controller } from 'stimulus'

/**
 * ExpandableController
 * Handles expand/collapse functionality for content sections
 */
export default class extends Controller {
  static targets = ['collapsed', 'expanded']
  static values = { recordId: String }

  connect() {
    // Start in collapsed state
    this.isExpanded = false
  }

  expand(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.hasCollapsedTarget && this.hasExpandedTarget) {
      this.collapsedTarget.classList.add('hidden')
      this.expandedTarget.classList.remove('hidden')
      this.isExpanded = true
    }
  }

  collapse(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.hasCollapsedTarget && this.hasExpandedTarget) {
      this.collapsedTarget.classList.remove('hidden')
      this.expandedTarget.classList.add('hidden')
      this.isExpanded = false
    }
  }

  toggle(event) {
    if (this.isExpanded) {
      this.collapse(event)
    } else {
      this.expand(event)
    }
  }
}
